import React from "react";
import DealerInfo from "./DealerInfo";
import DealerDirections from "./DealerDirections";
import DealerApprovedSales from "./DealerApprovedSales";
import { useUscSelector } from "../../../../redux/store";
import * as Styles from "./PdpDealer.styles";

const PdpDealer = (): JSX.Element | null => {
    const dealerState = useUscSelector((state) => state.dealer);

    if (dealerState.failed || !dealerState.initialized || !dealerState.dealer) return null;

    return (
        <Styles.Wrapper>
            <DealerInfo />
            <DealerDirections />
            <DealerApprovedSales />
        </Styles.Wrapper>
    );
};

export default PdpDealer;
